// import React, { useState, useEffect } from 'react';
// import { Container, Spinner } from 'react-bootstrap';
// import NavbarComponent from './SenseNavBar';
// import DashboardCards from './DashboardCards';
// import BodyTemperatureChart from './BodyTemperatureChart';
// import ActivityChart from './activitychart';
// import Footer from './Footer';
// import ActivityTrackChart from './activitytrackchart';

// function Dashboard() {
//   const [isLoading, setIsLoading] = useState(true);
//   const [activeChart, setActiveChart] = useState('');

//   useEffect(() => {
//     setTimeout(() => {
//       setIsLoading(false);
//     }, 2000);
//   }, []);

//   return (
//     <div className="dashboard-wrapper">
//       <NavbarComponent />
//       <Container fluid className="dashboard-content">
//         <h5 className="text-center mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
//           Patient Vitals Dashboard
//         </h5>
//         {isLoading ? (
//           <div className="text-center">
//             <Spinner animation="grow" variant="primary" />
//             <Spinner animation="grow" variant="primary" />
//             <Spinner animation="grow" variant="primary" />
//             <p>Loading...</p>
//           </div>
//         ) : (
//           <>
//             <DashboardCards setActiveChart={setActiveChart} />
//             {activeChart && (
//               <div className="chart-wrapper">
//                 {activeChart === 'temperature' && <BodyTemperatureChart />}
//                 {activeChart === 'activity' && <ActivityChart />}
//                 {activeChart === 'activitytrack' && <ActivityTrackChart/>}
//               </div>
//             )}
//           </>
//         )}
//       </Container>
//       <Footer />
//     </div>
//   );
// }

// export default Dashboard;

import React, { useState, useEffect } from "react";
import { Container, Spinner, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
// import { API_URL } from "../../config/config";
import NavbarComponent from "./SenseNavBar";
import DashboardCards from "./DashboardCards";
import BodyTemperatureChart from "./BodyTemperatureChart";
import ActivityChart from "./activitychart";
import Footer from "./Footer";
import ActivityTrackChart from "./activitytrackchart";

const API_URL = process.env.REACT_APP_API_URL;


function Dashboard() {
  const { patientId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [activeChart, setActiveChart] = useState("");
  const [patientData, setPatientData] = useState(null);
  const navigate = useNavigate();

  const handleBackToPatientsList = () => {
    navigate("/patients");
  };

  useEffect(() => {
    if (!patientId) return;

    const fetchPatientData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${API_URL}/patient/patients/${patientId}`
        );
        setPatientData(response.data);
      } catch (error) {
        console.error("Failed to fetch patient data:", error);
        setPatientData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPatientData();
  }, [patientId]);

  return (
    <div className="dashboard-wrapper">
      <NavbarComponent />
      <Container fluid className="dashboard-content">
        <div className="position-relative mb-4" style={{ minHeight: "48px" }}>
          <h5
            className="text-center position-absolute top-50 start-50 translate-middle"
            style={{ fontSize: "2.5rem", fontWeight: "bold", width: "100%" }}
          >
            {patientData
              ? `${patientData.patient_name}'s Vitals Dashboard`
              : "Patient Vitals Dashboard"}
          </h5>
          <Button
            variant="secondary"
            onClick={handleBackToPatientsList}
            style={{
              position: "absolute",
              top: "50%",
              right: 0,
              transform: "translateY(-50%)",
            }}
          >
            Back to Patients List
          </Button>
        </div>

        {isLoading ? (
          <div className="text-center">
            <Spinner animation="grow" variant="primary" />
            <Spinner animation="grow" variant="primary" />
            <Spinner animation="grow" variant="primary" />
            <p>Loading...</p>
          </div>
        ) : (
          <>
            <DashboardCards
              patientId={patientId}
              setActiveChart={setActiveChart}
            />
            {activeChart && (
              <div className="chart-wrapper">
                {activeChart === "temperature" && (
                  <BodyTemperatureChart patientId={patientId} />
                )}
                {activeChart === "activity" && (
                  <ActivityChart patientId={patientId} />
                )}
                {activeChart === "activitytrack" && (
                  <ActivityTrackChart patientId={patientId} />
                )}
              </div>
            )}
          </>
        )}
      </Container>
      <Footer />
    </div>
  );
}

export default Dashboard;
